import { DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEDIAccuracyDetail extends Layout {
    labelAdded: Label;
    labelComplianceDetail3: Label;
    labelComplianceDetail4: Label;
    labelComplianceDetail: Label;
    labelDividend: Label;
    labelDivisor: Label;
    labelLeftParen: Label;
    labelRightParen: Label;
    labelSubtracted: Label;
    labelWeight: Label;
    panelFormula: Panel;
    sourceCarrierScorecardDetail: DataSource;
    tabScoringDetails: Tab;
    tabsetScoringDetails: Tabset;
    textboxEndOfPeriod: Textbox;
    textboxMeasure: Textbox;
    textboxMinimumTransactions: Textbox;
    textboxStartOfPeriod: Textbox;
    textboxWeight: Textbox;
}
